import * as _ from 'lodash'
import { database } from '@/js/store/services/firebase.service'

const db = database()
function defaultSitePreferences() {
  return {
    favicon: '',
    thumbnail: '',
    seoSettings: {
      allowRobots: {
        all: false,
        pages: {},
      },
    },
  }
}

export default {
  namespaced: true,
  state: {
    sitePreferencesRef: null,
    preferences: defaultSitePreferences(),
  },
  mutations: {
    update(state, preferences) {
      state.preferences = preferences
    },
    save(state, { key, value }) {
      _.set(state.preferences, key, value)
    },
  },
  actions: {
    async init({ state, commit }, fbSitePath) {
      if (state.sitePreferencesRef) {
        state.sitePreferencesRef.off('value')
      }

      state.sitePreferencesRef = db.ref(fbSitePath).child('preferences')

      state.sitePreferencesRef.on('value', (snap) => {
        const preferences = snap.val()

        if (!preferences) {
          state.sitePreferencesRef
            .set(defaultSitePreferences())
            .catch((err) => {
              console.error('failed to set site preferences', err)
            })
        }

        if (preferences !== null) {
          commit('update', preferences)
        }
      })
    },
    async save({ state, commit }, { key, value }) {
      if (!key) {
        throw new Error('Missing key when updating site preferences')
      }

      commit('save', { key, value })
      await state.sitePreferencesRef.child(key).set(value)
    },
  },
}
